import { createContext, useContext, type ReactNode } from 'react';

export type AppFrame = 'fullscreen' | 'embedded';

const AppFrameContext = createContext<AppFrame>('fullscreen');

export function AppFrameProvider({
  frame,
  children,
}: {
  frame: AppFrame;
  children: ReactNode;
}): React.JSX.Element {
  return <AppFrameContext.Provider value={frame}>{children}</AppFrameContext.Provider>;
}

export function useAppFrame(): AppFrame {
  return useContext(AppFrameContext);
}
